import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ProgressSpinner } from "primeng/progressspinner";
import { NewUiGlobalSpinnerService } from "./new-ui-global-spinner.service";

@Component({
  selector: "new-ui-global-spinner",
  templateUrl: "./new-ui-global-spinner.component.html",
  imports: [AsyncPipe, ProgressSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiGlobalSpinnerComponent {
  protected readonly show$ = this.service.show$;

  constructor(private readonly service: NewUiGlobalSpinnerService) {}
}
